require ("./textToggle.scss");
const PropTypes = require('prop-types');
// @ commons
import { recordLink,recordLinkV2, EVENT_TOGGLE_ON, EVENT_TOGGLE_OFF, CARD_TOGGLE } from 'utilities/tagging';
// @ vendor
const React = require('react');
const classNames = require('classnames');

class TextToggle extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick = (evt) => {
        const checkbox = this.checkboxChecked;
        evt.stopPropagation();
        if (evt.target !== checkbox && this.props.checked) {
            evt.preventDefault();
            checkbox.focus();

            this.props.onClick(!checkbox.checked);
            this.tagToggle(EVENT_TOGGLE_OFF)
        } else {
            this.props.onClick(checkbox.checked);
            this.tagToggle(EVENT_TOGGLE_ON)
        }
    }

    tagToggle = (eventName) => {
        const {
            eventCategory,
            eventTag
        } = this.props
            eventCategory && eventTag && recordLink(eventCategory, eventName || this.props.eventName, eventTag)
    }

    render(){
        const {
            checked,
            defaultChecked,
            isCardControlSection,
            partiallyUnchecked,
            textCheck,
            textPartiallyCheck,
            textUncheck,
        } = this.props;
        const isChecked = (checked || defaultChecked) && !partiallyUnchecked;
        const classes = classNames('text-toggle', {
          'text-toggle--checked': isChecked,
          'text-toggle--partially': partiallyUnchecked,
        });
        const trackClasses = classNames('text-toggle-track', {
            'text-toggle-track--checked': isChecked && !isCardControlSection,
            'text-toggle-track--checked-card-control': isChecked && isCardControlSection,
            'text-toggle-track--partially': partiallyUnchecked,
        });

        const textClasses = classNames('text-toggle-text', {
            'text-toggle-text--checked': isChecked,
            'text-toggle-text--partially': partiallyUnchecked,
        })
        let text;

        if (!partiallyUnchecked) {
            text = isChecked ? textCheck : textUncheck;
        } else {
            text = textPartiallyCheck;
        }

        return (
            <div className={classes} onClick={this.handleClick}>
                <div className={trackClasses} />
                <div className="text-toggle-thumb" />
                <div className={textClasses}>
                    <span>{text}</span>
                </div>
                <input className="text-toggle-screenreader-only"
                    defaultChecked={checked}
                    ref={(checkbox) => this.checkboxChecked = checkbox}
                    type="checkbox"
                />
            </div>
        )
    }
}
TextToggle.propTypes = {
    checked: PropTypes.bool,
    defaultChecked: PropTypes.bool,
    id: PropTypes.string,
    isCardControlSection: PropTypes.bool,
    name: PropTypes.string,
    partiallyUnchecked: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    eventCategory: PropTypes.string,
    eventTag: PropTypes.string,
    eventName: PropTypes.string,
    textCheck: PropTypes.string,
    textPartiallyCheck: PropTypes.string,
    textUncheck: PropTypes.string,
    immCard: PropTypes.object,
    cardIndex: PropTypes.number
};

TextToggle.defaultProps = {
    defaultChecked: false,
    isCardControlSection: false,
    immCard:{},
    cardIndex:0
};

module.exports = TextToggle;